import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link, NavLink } from 'react-router-dom';

const About = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  const buttonVariants = {
    hover: {
      scale: 1.1,
      textShadow: '0px 0px 8px rgb(255, 255, 255)',
      boxShadow: '0px 0px 8px rgb(255, 255, 255)',
      transition: {
        duration: 0.3,
        yoyo: Infinity,
      },
    },
  };

  React.useEffect(() => {
    if (inView) {
      controls.start('visible');
    } else {
      controls.start('hidden');
    }
  }, [controls, inView]);

  const variants = {
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.8 },
  };

  return (
    <motion.div
      id="about"
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={variants}
      className="min-h-screen flex flex-col md:flex-row items-center justify-center text-center md:text-left bg-[#ffffff] p-8 space-y-8 md:space-y-0 md:space-x-8 shadow-lg rounded-lg"  // Added shadow-lg here
    >
      {/* Full container with shadow */}
      <div className="flex flex-row w-full max-w-[90%] h-[80vh] rounded-lg overflow-hidden bg-white shadow-[-15px_15px_15px_rgba(0,0,0,0.3),10px_-10px_10px_rgba(255,255,255,0.7)]">
        {/* Text Section */}
        <div className="w-1/2 flex flex-col justify-center p-8 md:p-16 bg-gray-50 space-y-6">
          <h2 className="text-[50px] font-bold text-[#000000]">
            About Us
          </h2>
          <p className="text-[24px] text-[#000000] font-semibold">
            TranXEnergy is dedicated to empowering businesses and communities to
            achieve sustainable growth through innovative environmental, social, and
            governance (ESG) solutions. Our commitment to eco-friendly practices
            drives us to deliver exceptional value while preserving our planet for
            future generations.
          </p>
          <b></b>
          <motion.div variants={buttonVariants} whileHover="hover">
            <NavLink
              to="" //Add link to the "Get to know us!"
              className="bg-[#82921B] text-[#ffffff] font-Inter font-12px px-6 py-3 rounded-full font-semibold shadow-lg transition-all transform hover:-translate-y-1"
            >
              Get to know us!
            </NavLink>
          </motion.div>
          <b></b>
        </div>

        {/* Image Section */}
        <motion.div
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.5 }}
          className="w-1/2 h-full"
        >
          <img
            src="/Home_Page_3.jpeg" // Ensure this is the correct path and file extension
            alt="Home_Page_3"
            className="w-full h-full object-cover shadow-lg" // Make sure the image fills the space
          />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default About;
